"use client";

import { AppProvider } from "@/context/appContext";

export default function Providers({ children }) {
  return <AppProvider>{children}</AppProvider>;
}
